import React, { PropsWithChildren, createContext, useContext } from "react";

interface PageBannerContextType {
	size: "small" | "large";
	color: "primary" | "green" | "red";
}

const PageBannerContext = createContext<PageBannerContextType | undefined>(undefined);

export const usePageBannerContext = () => {
	const context = useContext(PageBannerContext);
	if (!context) {
		throw new Error("usePageBannerContext must be used within a PageBannerProvider");
	}
	return context;
};

export const PageBannerProvider: React.FC<PropsWithChildren<PageBannerContextType>> = ({
	size = "small",
	color,
	children,
}) => {
	return (
		<PageBannerContext.Provider
			value={{
				size,
				color,
			}}
		>
			{children}
		</PageBannerContext.Provider>
	);
};
